import PropTypes from "prop-types"; 
import { useLocation } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
import {
  Box,
  Drawer,
  IconButton,
} from "@mui/material";

// hooks
import useResponsive from "../../Hooks/hooks";
// components
import { ReactComponent as SaedLogo } from "../../Assets/Dashboard/Sidebar/saedlogo.svg";
import Scrollbar from "../../Components/Dashboard/Scrollbar";
import NavSection from "../../Components/Dashboard/NavSection";
//
import sidebarConfig from "../../Routes/SidebarConfig";
import Iconify from "../../Components/Dashboard/Iconify";

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;

const RootStyle = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
  },
}));


DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar }) {

  const isDesktop = useResponsive("up", "lg");

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Box
        sx={{
          pl: 6,
          py: 3,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 700,
          color: "#141213",
          fontFamily: "Poppins, sans-serif",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <SaedLogo />
          NYSC<span style={{ color: "#F0B811" }}>SAED</span>
        </Box>
        <Box>
          <IconButton
            onClick={onCloseSidebar}
            sx={{
              mr: 1,
              color: "text.secondary",
              fontSize: 25,
              display: { lg: "inline-flex" },
            }}
          >
            <Iconify icon="ic:round-keyboard-arrow-left" />
          </IconButton>
        </Box>
      </Box>

      <NavSection navConfig={sidebarConfig} />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <RootStyle>
      {!isDesktop && (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open={!isOpenSidebar}
          sx={{
            width: DRAWER_WIDTH,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: DRAWER_WIDTH,
              boxSizing: "border-box",
              borderRightStyle: "dashed",
              bgcolor: "background.default",
            },
          }}
          variant="persistent"
          anchor="left"
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
